export default "__VITE_ASSET__BGozVDJ5__"